export function formatPrice(price){
    return price.toFixed(2)
}